// Import React and useState for state management
import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom'; // added useNavigate

// Import user, lock, and eye icons from react-icons
import { FaUser, FaLock } from "react-icons/fa";
import { FiEye, FiEyeOff } from "react-icons/fi";

function Login() {
  // State variables for input fields and checkbox
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const navigate = useNavigate(); // initialize navigate

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Logging in:", { email, password, rememberMe });

    // Example: navigate to AdminPage after login
    navigate('/admin');
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        {/* User avatar */}
        <div style={styles.avatar}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/847/847969.png"
            alt="User avatar"
            style={{ width: 80, height: 80, borderRadius: "50%" }}
          />
        </div>

        {/* Login heading */}
        <h2 style={styles.title}>Login</h2>

        {/* Form */}
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <FaUser style={styles.icon} />
            <input
              type="email"
              placeholder="Username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              required
            />
          </div>

          <div style={styles.inputGroup}>
            <FaLock style={styles.icon} />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              required
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={styles.eyeIcon}
              title={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </span>
          </div>

          <div style={styles.options}>
            <label>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />{" "}
              Remember me
            </label>
            <a href="#" style={styles.link}>
              Forgot password?
            </a>
          </div>

          {/* Submit button */}
          <button type="submit" style={styles.button}>
            LOGIN
          </button>

          {/* Sign up prompt */}
          <p style={styles.signupPrompt}>
            Don’t have an account?{" "}
            <Link to="/signup" style={styles.link}>Sign up</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

// Inline styles
const styles = {
  wrapper: {
    minHeight: "100vh",
    height: "100vh",
    background: "#e6f0fa",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  card: {
    backgroundColor: "#ffffff",
    padding: "5vw",
    borderRadius: "15px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    width: "90%",
    maxWidth: "400px",
    textAlign: "center",
  },
  avatar: {
    marginBottom: "10px",
  },
  title: {
    fontSize: "24px",
    color: "#007bff",
    marginBottom: "25px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  inputGroup: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  icon: {
    position: "absolute",
    left: "12px",
    color: "#777",
  },
  eyeIcon: {
    position: "absolute",
    right: "12px",
    color: "#777",
    cursor: "pointer",
  },
  input: {
    width: "100%",
    padding: "12px 40px 12px 36px",
    fontSize: "15px",
    border: "1px solid #ccc",
    borderRadius: "25px",
    outline: "none",
  },
  options: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "14px",
    color: "#555",
    marginTop: "5px",
  },
  link: {
    textDecoration: "none",
    color: "#007bff",
  },
  button: {
    width: "100%",
    marginTop: "15px",
    padding: "12px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "25px",
    cursor: "pointer",
  },
  signupPrompt: {
    marginTop: "15px",
    fontSize: "14px",
    color: "#555",
  }
};

export default Login;
